package com.essntl.features.country.ui.allcountries

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.country.ui.allcountries.components.CountryItem
import com.essntl.uikit.components.button.primary.EsSmallPrimaryButton
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun AllCountriesScreen(
    state: AllCountriesState,
    onEvent: (AllCountriesEvent) -> Unit,
    onNavigation: (AllCountriesNavigation) -> Unit,
) {
    Column(
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.Start,
        modifier = Modifier.fillMaxWidth(),
    ) {
        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = Modifier.fillMaxWidth(),
        ) {
            Text(
                text = "Countries",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )

            EsSmallPrimaryButton(
                text = "Add country",
                suffixIconRes = EsIcons.Add,
                onClick = {
                    onNavigation(AllCountriesNavigation.AddCountry)
                },
            )
        }

        Spacer(modifier = Modifier.height(2.spacing))

        if (state.getAllCountries.isLoading)
            EsSpinner()
        else if (state.getAllCountries.isFailure)
            Text(
                text = "Something goes wrong!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        else if (state.getAllCountries.data
                .orEmpty()
                .isEmpty()
        )
            Text(
                text = "No countries found!",
                color = MaterialTheme.esColorScheme.textSecondary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        else
            FlowRow(
                horizontalArrangement = Arrangement.spacedBy(2.spacing),
                verticalArrangement = Arrangement.spacedBy(2.5.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                for (country in state.getAllCountries.data.orEmpty())
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(1.spacing),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        CountryItem(country = country)

                        EsSmallOutlineIconButton(
                            iconRes = EsIcons.Edit,
                            onClick = {
                                onNavigation(AllCountriesNavigation.EditCountry(country))
                            },
                        )
                    }
            }
    }
}